import React from "react";
import { Link } from "react-router-dom";
import { LogoMark } from "../components/Logo";
import { ChevronLeft } from "lucide-react";

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-[#0A0E27] py-8 px-4" data-testid="privacy-page">
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <Link to="/" className="flex items-center gap-2 text-[#3B82F6] hover:text-black text-sm">
            <ChevronLeft className="w-4 h-4"/> Home
          </Link>
          <LogoMark className="w-9 h-9"/>
        </div>
        <article className="bg-white border border-black rounded-3xl p-8 md:p-12 prose-verixa">
          <div className="text-xs uppercase tracking-widest text-[#757575] mb-2">Versione 1.0 · 17 Maggio 2026</div>
          <h1 className="font-display text-4xl mb-2">Informativa sulla Privacy</h1>
          <p className="text-sm text-[#555] mb-6">Resa ai sensi degli articoli 13 e 14 del Regolamento (UE) 2016/679 (GDPR).</p>

          <Section title="1. Titolare e Responsabile">
            <p><strong>Verixa srl</strong> agisce come <strong>Responsabile del trattamento</strong> per conto delle aziende clienti (Titolari).
            Per i dati dei visitatori del sito pubblico Verixa è invece Titolare diretto.</p>
            <p>Contatti DPO/privacy: <a href="mailto:privacy@verixa.it" className="text-[#3B82F6]">privacy@verixa.it</a></p>
          </Section>

          <Section title="2. Dati trattati">
            <ul>
              <li><strong>Dati anagrafici</strong>: nome, cognome, codice fiscale, telefono, email, indirizzo.</li>
              <li><strong>Credenziali</strong>: email + password (sempre hashata bcrypt, mai conservata in chiaro).</li>
              <li><strong>Dati operativi</strong>: timbrature, geolocalizzazione GPS al momento del check-in, foto QR opzionali.</li>
              <li><strong>Dati lavorativi</strong>: ferie, permessi, malattia, rimborsi spese, turni, commesse, documenti firmati.</li>
              <li><strong>Dati di pagamento</strong>: trattati esclusivamente da Stripe; Verixa non conserva carte di credito.</li>
              <li><strong>Metadati</strong>: indirizzo IP, user agent, log accessi (per sicurezza).</li>
            </ul>
          </Section>

          <Section title="3. Finalità e base giuridica">
            <ul>
              <li>Esecuzione del contratto di lavoro/servizio (art. 6.1.b GDPR)</li>
              <li>Obblighi legali (libro unico del lavoro, fiscali) (art. 6.1.c)</li>
              <li>Consenso esplicito per la registrazione autonoma del dipendente (art. 6.1.a)</li>
              <li>Legittimo interesse del Titolare per sicurezza e prevenzione frodi (art. 6.1.f)</li>
            </ul>
          </Section>

          <Section title="4. Periodi di conservazione">
            <ul>
              <li>Timbrature e dati presenza: <strong>5 anni</strong> (obbligo libro unico)</li>
              <li>Cedolini e payroll: <strong>10 anni</strong> (obbligo fiscale)</li>
              <li>Documenti firmati: <strong>10 anni</strong></li>
              <li>Richieste iscrizione rifiutate: <strong>30 giorni</strong>, poi cancellazione automatica</li>
              <li>Sessioni trasferta GPS: fino a fine mese, poi cancellazione automatica</li>
              <li>Log accessi: <strong>12 mesi</strong></li>
            </ul>
          </Section>

          <Section title="5. Destinatari e sub-responsabili">
            <p>I dati possono essere comunicati a:</p>
            <ul>
              <li><strong>MongoDB Atlas</strong> — hosting database (UE)</li>
              <li><strong>Resend</strong> — invio email transazionali</li>
              <li><strong>Stripe</strong> — pagamenti (PCI-DSS)</li>
              <li><strong>Google</strong> — solo se attivi opzionalmente la sincronizzazione Calendar</li>
              <li><strong>Emergent Hosting</strong> — infrastruttura applicativa</li>
            </ul>
            <p>Tutti i sub-responsabili sono vincolati da DPA art. 28 GDPR.</p>
          </Section>

          <Section title="6. Trasferimenti extra-UE">
            <p>Eventuali trasferimenti extra-SEE avvengono esclusivamente sulla base di Clausole Contrattuali Standard (SCC) della Commissione Europea o decisioni di adeguatezza.</p>
          </Section>

          <Section title="7. Diritti dell'interessato">
            <p>Hai il diritto di:</p>
            <ul>
              <li><strong>Accesso</strong> (art. 15) — scaricare i tuoi dati da <em>Profilo → I miei dati</em></li>
              <li><strong>Rettifica</strong> (art. 16) — correggere i dati dal tuo profilo</li>
              <li><strong>Cancellazione</strong> (art. 17) — eliminare account da <em>Profilo → Cancella account</em></li>
              <li><strong>Portabilità</strong> (art. 20) — export JSON dei tuoi dati</li>
              <li><strong>Opposizione</strong> e <strong>limitazione</strong> (artt. 18, 21)</li>
              <li><strong>Reclamo al Garante</strong> — <a href="https://www.garanteprivacy.it" className="text-[#3B82F6]">www.garanteprivacy.it</a></li>
            </ul>
          </Section>

          <Section title="8. Sicurezza">
            <ul>
              <li>Connessioni cifrate TLS 1.3</li>
              <li>Password hashate con bcrypt</li>
              <li>Controllo accessi role-based (RBAC) multi-tenant</li>
              <li>Backup periodici automatici</li>
              <li>Audit log accessi ai dati sensibili</li>
            </ul>
          </Section>

          <Section title="9. Cookie">
            <p>Utilizziamo esclusivamente cookie tecnici essenziali al funzionamento (sessione, preferenze). Nessun cookie di profilazione o marketing.</p>
          </Section>

          <p className="text-xs text-[#757575] mt-8">Per esercitare i tuoi diritti scrivi a <a href="mailto:privacy@verixa.it" className="text-[#3B82F6]">privacy@verixa.it</a>. Rispondiamo entro 30 giorni.</p>
        </article>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div className="mt-6">
      <h2 className="font-display text-2xl text-[#3B82F6] mb-3">{title}</h2>
      <div className="text-sm text-[#333] leading-relaxed space-y-2">
        {children}
      </div>
    </div>
  );
}
